import styled from 'styled-components';
import { ScopedCssBaseline } from '@planne-software/uni/mui/material';
import { device } from '@src/common/breakpoints';

export const StyledScopedCssBaseline = styled(ScopedCssBaseline)`
  && {
    background: transparent;
    width: 100%;

    ${device.smallTablet} {
      width: auto;
    }
  }
`;
